import { InsightActionTypes, AngleKey, PovData } from './insightTypes';

export const insightApiResponseSuccess = (actionType: string, data: any) => ({
  type: InsightActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

export const insightApiResponseError = (actionType: string, error: string) => ({
  type: InsightActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// Trigger distill (saga picks this up)
export const distillAction = (thought: string) => ({
  type: InsightActionTypes.DISTILL,
  payload: { thought },
});

export const selectAngle = (angle: AngleKey) => ({
  type: InsightActionTypes.SELECT_ANGLE,
  payload: { angle },
});

// Hydrate insight from explore summarise response
export const hydrateFromExplore = (data: {
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  rawThought: string;
}) => ({
  type: InsightActionTypes.HYDRATE_FROM_EXPLORE,
  payload: data,
});

// Hydrate from library card (full insight data)
export const hydrateFromLibrary = (data: {
  rawThought: string;
  distilledInsight: string;
  topic: string;
  toneTags: string[];
  hook: string;
  pov: PovData | null;
  selectedAngle: AngleKey;
  insightId: string;
}) => ({
  type: InsightActionTypes.HYDRATE_FROM_LIBRARY,
  payload: data,
});

// Set insightId + packId after save
export const confirmSave = (insightId: string) => ({
  type: InsightActionTypes.CONFIRM_SAVE,
  payload: { insightId },
});

export const setExploreSessionId = (sessionId: string) => ({
  type: InsightActionTypes.SET_EXPLORE_SESSION_ID,
  payload: { sessionId },
});

export const resetInsight = () => ({
  type: InsightActionTypes.RESET,
});
